import React from 'react';
import { Box, Container, Grid, Typography } from '@mui/material';
import BielendaVideo from '../../assets/Bielenda Water (Short 3 v1).mp4';

const Page3 = () => {
    return (
        <Container
            sx={{
                paddingTop: '50px',
                paddingBottom: '50px',
                backgroundColor: '#FFFFFF',
                borderRadius: '20px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}
        >
            <Grid container spacing={6} alignItems="center">
                {/* Left Column - Video */}
                <Grid item xs={12} md={6}>
                    <Box
                        component="video"
                        src={BielendaVideo}
                        autoPlay
                        loop
                        muted
                        playsInline

                        sx={{
                            width: '100%',
                            height: 'auto',
                            borderRadius: '20px',
                            objectFit: 'cover',
                        }}
                    />
                </Grid>

                {/* Right Column - Text */}
                <Grid item xs={12} md={6}>
                    <Box sx={{ paddingLeft: { xs: 0, md: '20px' } }}>
                        <Typography
                            sx={{
                                fontFamily: 'ClaireMurphy',
                                fontSize: {
                                    xs: '28px',
                                    sm: '34px',
                                    md: '40px',
                                },
                                fontWeight: 400,
                                lineHeight: {
                                    xs: '36px',
                                    sm: '42px',
                                    md: '50px',
                                },
                                textAlign: 'left',
                                color: 'rgba(61, 61, 61, 1)',
                                marginBottom: {
                                    xs: '20px',
                                    md: '30px',
                                },
                            }}
                        >
                            WHAT MAKES SUPREMELAB STAND OUT?
                        </Typography>
                        <Typography
                            sx={{
                                fontFamily: 'Quicksand, sans-serif',
                                fontSize: {
                                    xs: '16px',
                                    md: '18px',
                                },
                                fontWeight: 400,
                                lineHeight: {
                                    xs: '24px',
                                    md: '28px',
                                },
                                textAlign: 'left',
                                color: 'rgba(136, 136, 136, 1)',
                                marginBottom: '30px',
                            }}
                        >
                            The Bielenda Supremelab brand is characterized by its foundation in experience gained from creating cosmetic treatments and its inspiration from effective solutions in this field. These cosmetics are designed for professional home care.
                        </Typography>
                        <Box sx={{ marginBottom: '30px' }}>
                            <Typography
                                sx={{
                                    fontFamily: 'Quicksand, sans-serif',
                                    fontSize: {
                                        xs: '18px',
                                        md: '20px',
                                    },
                                    fontWeight: 500,
                                    lineHeight: {
                                        xs: '26px',
                                        md: '30px',
                                    },
                                    textAlign: 'left',
                                    color: 'rgba(61, 61, 61, 1)',
                                    marginBottom: '20px',
                                }}
                            >
                                Here are the most important features of Bielenda Supremelab products:
                            </Typography>
                            <Box component="ul" sx={{ paddingLeft: '20px', margin: 0 }}>
                                <Typography
                                    component="li"
                                    sx={{
                                        fontFamily: 'Quicksand, sans-serif',
                                        fontSize: {
                                            xs: '16px',
                                            md: '18px',
                                        },
                                        fontWeight: 400,
                                        lineHeight: {
                                            xs: '24px',
                                            md: '28px',
                                        },
                                        textAlign: 'left',
                                        color: 'rgba(136, 136, 136, 1)',
                                        marginBottom: '15px',
                                    }}
                                >
                                    The lines are aimed at solving specific skin problems.
                                </Typography>
                                <Typography
                                    component="li"
                                    sx={{
                                        fontFamily: 'Quicksand, sans-serif',
                                        fontSize: {
                                            xs: '16px',
                                            md: '18px',
                                        },
                                        fontWeight: 400,
                                        lineHeight: {
                                            xs: '24px',
                                            md: '28px',
                                        },
                                        textAlign: 'left',
                                        color: 'rgba(136, 136, 136, 1)',
                                        marginBottom: '15px',
                                    }}
                                >
                                    We use combinations of proven, effective ingredients in optimal concentrations.
                                </Typography>
                                <Typography
                                    component="li"
                                    sx={{
                                        fontFamily: 'Quicksand, sans-serif',
                                        fontSize: {
                                            xs: '16px',
                                            md: '18px',
                                        },
                                        fontWeight: 400,
                                        lineHeight: {
                                            xs: '24px',
                                            md: '28px',
                                        },
                                        textAlign: 'left',
                                        color: 'rgba(136, 136, 136, 1)',
                                        marginBottom: '15px',
                                    }}
                                >
                                    We always put product effectiveness first.
                                </Typography>
                                <Typography
                                    component="li"
                                    sx={{
                                        fontFamily: 'Quicksand, sans-serif',
                                        fontSize: {
                                            xs: '16px',
                                            md: '18px',
                                        },
                                        fontWeight: 400,
                                        lineHeight: {
                                            xs: '24px',
                                            md: '28px',
                                        },
                                        textAlign: 'left',
                                        color: 'rgba(136, 136, 136, 1)',
                                        marginBottom: '15px',
                                    }}
                                >
                                    Our products are characterized by advanced technology, high activity and concentration of active substances.
                                </Typography>
                                <Typography
                                    component="li"
                                    sx={{
                                        fontFamily: 'Quicksand, sans-serif',
                                        fontSize: {
                                            xs: '16px',
                                            md: '18px',
                                        },
                                        fontWeight: 400,
                                        lineHeight: {
                                            xs: '24px',
                                            md: '28px',
                                        },
                                        textAlign: 'left',
                                        color: 'rgba(136, 136, 136, 1)',
                                        marginBottom: '15px',
                                    }}
                                >
                                    We ensure comfortable, safe formulas and appropriate penetration promoters that improve the effectiveness of our cosmetics.
                                </Typography>
                                <Typography
                                    component="li"
                                    sx={{
                                        fontFamily: 'Quicksand, sans-serif',
                                        fontSize: {
                                            xs: '16px',
                                            md: '18px',
                                        },
                                        fontWeight: 400,
                                        lineHeight: {
                                            xs: '24px',
                                            md: '28px',
                                        },
                                        textAlign: 'left',
                                        color: 'rgba(136, 136, 136, 1)',
                                        marginBottom: '15px',
                                    }}
                                >
                                    We create trends, take advantage of innovations emerging in the beauty industry and the latest achievements in cosmetology.
                                </Typography>
                            </Box>
                        </Box>
                        <Typography
                            sx={{
                                fontFamily: 'Quicksand, sans-serif',
                                fontSize: {
                                    xs: '16px',
                                    md: '18px',
                                },
                                fontWeight: 400,
                                lineHeight: {
                                    xs: '24px',
                                    md: '28px',
                                },
                                textAlign: 'left',
                                color: 'rgba(136, 136, 136, 1)',
                            }}
                        >
                            These products are for everyone who demands more from their skincare. For conscious individuals seeking measurable results, effectiveness, and also pleasure and safety of use.
                        </Typography>
                    </Box>
                </Grid>
            </Grid>
        </Container>
    );
};

export default Page3;
